import ReactEChartsCore from 'echarts-for-react/lib/core';
import * as echarts from 'echarts/core';

//import PropTypes from 'prop-types';
import React, { useEffect, useState } from 'react';
import { Card, Col, Row } from 'react-bootstrap';
//import { chartJsDefaultTooltip } from '../../helpers/chartjs-utils';
import {
    PieChart
} from 'echarts/charts';
import {
    LegendComponent,
    TooltipComponent
} from 'echarts/components';
import {
    CanvasRenderer
} from 'echarts/renderers';
import DatePicker from "react-datepicker";
import Skeleton from 'react-loading-skeleton';
import useToken from 'hooks/useToken';
echarts.use([PieChart, TooltipComponent, LegendComponent, CanvasRenderer]);
import { useToast } from 'context/providers/ToastProvider';
const DonutSoporteCard = () => {

    const [soporteData, setSoporteData] = useState([]);
    const [cargando, setCargando] = useState(false);
    const { setToken, token } = useToken();
    const [selectedDate, setSelectedDate] = useState(new Date());
    const tickets = soporteData.map(item => item.tickets);
    const totalTickets = tickets.reduce((a, b) => a + b, 0);
    const { showErrorToast } = useToast();
    const chartData = soporteData.map(item => ({
        name: item.nombre,
        value: item.tickets
    }));


    const option = {
        tooltip: {
            trigger: 'item',
            formatter: '{b}: {c} tickets ({d}%)'
        },
        legend: {
            orient: 'vertical',
            right: 10,
            top: 'center'
        },
        series: [
            {
                name: 'Contribution',
                type: 'pie',
                radius: ['40%', '70%'],
                avoidLabelOverlap: false,
                label: {
                    show: true,
                    position: 'outside',
                    formatter: '{b}: {d}%'
                },
                labelLine: {
                    show: true
                },
                data: chartData
            }
        ]
    };


    //obtiene la tabla de soporte tecnico
    const GetTicketsPorAgenteMes = async () => {
        setCargando(true);
        const formattedDate = new Date(selectedDate).toISOString().split('T')[0];
        const response = await fetch("/api/soportetecnico/GetTicketsPorAgenteMes/?date=" + formattedDate,
            {
                method: 'GET',
                headers:
                {
                    'Authorization': 'Bearer ' + token,
                    'Content-Type': 'application/json'
                }
            });

        if (response.ok) {
            const data = await response.json();
            // Asegurar formato correcto
            const formateado = data.map(item => ({
                nombre: item.nombre,
                tickets: item.tickets
            }));

            setSoporteData(formateado);


        }
        else {
            showErrorToast(response.status + ' ' + response.statusText);
            if (response.status == 401) {
                setToken(null);
                location.href = "";
            }
            console.log(response);
        }
        setCargando(false);
    };

    useEffect(() => {
        GetTicketsPorAgenteMes();
    }, [selectedDate]);


    return (
        <Card className="shadow-sm">
            <Card.Header className="bg-light d-flex justify-content-between align-items-center">
                <Row>
                    <Col>
                        <div>
                            <h5 className="mb-0">Technical support contribution</h5>
                            <small className="text-muted">Selected Month | Total: {totalTickets} tickets</small>
                        </div>
                    </Col>
                </Row>

                <Row>
                    <Col>
                        <DatePicker
                            selected={selectedDate}
                            onChange={(date) => {
                                setSelectedDate(date);
                            }}
                            dateFormat="MMMM yyyy - QQQ"
                            className="form-control form-control-sm"
                            showMonthYearPicker
                            style={{ minWidth: '200px' }}
                        />
                    </Col></Row>
            </Card.Header>
            <Card.Body>
                <div style={{ margin: '0 auto' }}>
                    {cargando ?
                        <Skeleton width={100} height={50} className="mb-1" />
                        :
                        <ReactEChartsCore
                            echarts={echarts}
                            option={option}
                            style={{ height: '400px', width: '100%' }}
                        />
                    }
                </div>
            </Card.Body>
        </Card>
    );
};

DonutSoporteCard.propTypes = {
};

export default DonutSoporteCard;